import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a47f04921ae0867e8b110c863c43e6ce3b from "./generated-434ef42c-f5d6-474f-a32d-5bf3b6f32f14.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/bookmaker-settings"){
            
                    await direct(a47f04921ae0867e8b110c863c43e6ce3b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */